module.exports = __webpack_public_path__ + "static/media/ice-cream.ac1e4d26.jpg";